import { create } from "zustand";

/**
 * LoadingState Interface
 *
 * Defines the structure of the loading state for the application.
 */
interface LoadingState {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

/**
 * useLoadingStore Custom Hook
 *
 * Manages loading state for the application.
 */
export const useLoadingStore = create<LoadingState>((set) => ({
  loading: true,
  setLoading: (loading: boolean) => set({ loading }),
}));
